import { Icon, theme } from '@yuno/design-system-web'
import { useContext } from 'react'
import { FiltersContext } from '../../context/filters-context'
import { CustomBoxSearch, CustomInputSearch } from './styles'
import { useTranslation } from 'react-i18next'

export const FiltersInputSearch = () => {
  const {
    handleSetFilter,
    filter: { search },
  } = useContext(FiltersContext)
  const isTesting = localStorage.getItem('isTesting')
  const { t } = useTranslation()
  const handleInputChange = (event) => {
    const value = event?.target?.value
    handleSetFilter('search', value)
  }

  const removeFilter = () => {
    handleSetFilter('search', '')
  }

  return (
    <CustomBoxSearch isTesting={isTesting}>
      {search.length > 0 ? (
        <Icon
          onClick={removeFilter}
          name="X"
          size={'16px'}
          color={theme.palette.grey[5]}
          weight="thin"
        />
      ) : (
        <Icon
          name="MagnifyingGlass"
          size={'16px'}
          color={theme.palette.grey[5]}
          weight="thin"
        />
      )}
      <CustomInputSearch
        nonce='undefined'
        id="search"
        type={'text'}
        placeholder={t('search')}
        name={'search'}
        onChange={handleInputChange}
        value={search}
      />
    </CustomBoxSearch>
  )
}
